import * as React from 'react';
import { Icon3DTour16 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function ExcursionIcon(_ref) {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    onClick: onClick,
    children: /*#__PURE__*/_jsx(Icon3DTour16, {
      color: "icon-main-default"
    })
  });
}